import React, { useEffect, useState } from 'react'
//@ts-ignore
import InfoPopover from 'app/components/InfoPopover'
//@ts-ignore
import ArrowToCompletedActivity from 'app/components/SVGS/ArrowToCompletedActivity'
import { ICompletedActivityArrow } from './interface'

import './styles.scss'

const bc = 'completed-activity-arrow'

const CompletedActivityArrow: React.FC<ICompletedActivityArrow> = ({
  t,
  isMobile,
  isStoryActivatedForOrganization,
  limit,
  setFeatureAsShown,
  positionElement,
}) => {
  const middle = limit / 2
  const [renderArrowRigthSide, setRightSide] = useState(false)
  useEffect(
    () => {
      let domElement: HTMLElement = document.getElementsByClassName(bc)[0] as HTMLElement
      const LEFT = '0px'

      if (domElement) {
        domElement.style.position = 'absolute'

        // check how render got it popup
        setRightSide(positionElement > middle)

        const offset = limit - positionElement
        domElement.style.display = 'flex'
        domElement.style.left = 'auto'
        domElement.style.right = 'auto'
        if (renderArrowRigthSide) {
          domElement.style.right = `${100 / limit * offset - 10}%`
        } else {
          domElement.style.left = isMobile && !positionElement ? LEFT : `${100 / limit * positionElement - 2}%`
        }
      }
    },
    [limit, renderArrowRigthSide]
  )

  return (
    <div className={bc}>
      {!renderArrowRigthSide && <ArrowToCompletedActivity />}
      <InfoPopover
        className={`${bc}__popup`}
        text={
          isStoryActivatedForOrganization
            ? t('Click here to see activity details or to add a story to your completed action')
            : t('Click here to see activity details')
        }
        action={() => setFeatureAsShown({ dot: false })}
        messagePopup
      />
      {renderArrowRigthSide && <ArrowToCompletedActivity style={{ marginTop: 110, transform: 'scale(-1, 1)' }} />}
    </div>
  )
}


export default CompletedActivityArrow
